// extracted by mini-css-extract-plugin
export default {"order":"orders_order__zf0+g","product":"orders_product__8Ut-V","badges":"orders_badges__JdUV6","badge":"orders_badge__Cw2p1"};